export var RECOMMENDED_PLAYLIST_THUMBNAIL_SIZE = '1200×300—1200×600';
export var RECOMMENDED_ASSET_THUMBNAIL_SIZE = '1200×800';
export var RECOMMENDED_TOPIC_THUMBNAIL_SIZE = '200×750';